import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";
import { LogoV3 } from "@/libraries/wpl/foundations/src";
import {
    TryPageCard,
    TryPageHeader
} from "@/templates/try/try-page/components";

import { messages } from "../messages";

const sectionCss = css({
    padding: "32px 0",
    position: "relative",
    verticalAlign: "baseline",
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    minWidth: "100%"
});

const CodeBuildShipSection = () => {
    const intl = useIntl();

    const codeBuildShipHeaderText = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.headerText",
        defaultMessage: "Code, Build, & Ship"
    });

    const bitbucketBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.bitbucket.bodyText",
        defaultMessage:
            "Collaborate on code with inline comments and pull requests. Manage and share your Git repositories to build and ship software, as a team."
    });

    const sourcetreeBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.sourcetree.bodyText",
        defaultMessage:
            "Harness the full power of Git and Mercurial in a beautifully simple application. Get the free desktop client for Mac and Windows."
    });

    const compassBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.compass.bodyText",
        defaultMessage:
            "Bring your distributed software architecture and the teams that collaborate on it together in a single, unified place."
    });

    const rovoDevBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.rovoDev.bodyText",
        defaultMessage:
            "Stay in the flow longer with AI-enabled productivity and quality for the full software delivery lifecycle."
    });

    const tryCloud = intl.formatMessage(messages.tryCloud);

    const downloadNow = intl.formatMessage(messages.downloadNow);

    const bitbucketLogo = (
        <LogoV3 brand={"bitbucket"} type="logo" appearance="brand" />
    );

    const rovoLogo = (
        <LogoV3 brand={"rovodev"} type="logo" appearance="brand" />
    );

    const sourcetreeLogo = (
        <LogoV3 brand={"sourcetree"} type="logo" appearance="brand" />
    );

    const compassLogo = (
        <LogoV3 brand={"compass"} type="logo" appearance="brand" />
    );

    return (
        <UFOSegment css={sectionCss} name={"code-build-ship"}>
            <Row>
                <TryPageHeader
                    dividerColor={"#ff8b00"}
                    headerText={codeBuildShipHeaderText}
                />
            </Row>
            <Row layout="6-6">
                <TryPageCard
                    logo={bitbucketLogo}
                    link={useLocalizedHref("/software/bitbucket/bundle")}
                    bodyText={bitbucketBody}
                    ctaText={tryCloud}
                />
                <TryPageCard
                    logo={rovoLogo}
                    link={useLocalizedHref("/try/cloud/signup?bundle=devai")}
                    bodyText={rovoDevBody}
                    ctaText={tryCloud}
                />
            </Row>
            <div />
            <Row layout="6-6">
                <TryPageCard
                    logo={sourcetreeLogo}
                    link={"https://www.sourcetreeapp.com/"}
                    bodyText={sourcetreeBody}
                    ctaText={downloadNow}
                />
                <TryPageCard
                    logo={compassLogo}
                    link={useLocalizedHref("/try/cloud/signup?bundle=compass")}
                    bodyText={compassBody}
                    ctaText={tryCloud}
                />
            </Row>
        </UFOSegment>
    );
};

export default CodeBuildShipSection;
